/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import '../DevlopmentOrder.css';
import { uniq } from 'lodash';
import ProductInfoSubHeader from './Subheader';
import ProductListContainer from './ProductListContainer';
import { useProductInformationState } from './Provider';
import CompletionModal from './CompletionModal';
import ProductGroupModal from './ProductGroupModal';
import * as action from '../store/DevelopmentOrder.action';
import * as productListAction from '../../RangePlan/ProductList/store/ProductList.action';
import AddProductGroupModal from './AddProductGroupModal';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import { BombiixModal } from '../../../Components/BombiixModal';
import { NewTextArea } from '../../../Components/PIM/common/NewTextArea';
import ReorderList from './ProductListContainer/ReorderList';

function ProductInformation() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { state, setState, callGetDevorderListApi } = useProductInformationState();
  const { t } = useTranslation('common');

  useEffect(() => {
    if (sessionStorage.getItem('productInfoView') === 'table') {
      history.replace('/development-order-overview/table-view');
    }
  }, []);

  const handleCloseCompletionModal = () => {
    setState((prevData) => ({
      ...prevData,
      isCompletionModalOpen: false,
      currentProduct: null,
      completionData: null,
    }));
  };

  const handleCloseProductModal = () => {
    setState((prevData) => ({
      ...prevData,
      isProductGroupModalOpen: false,
      currentProduct: null,
      groupError: false,
      selectedIds: [],
      selectedGroups: [],
    }));
  };

  const handleOpenProductGroup = () => {
    setState((prevData) => ({
      ...prevData,
      isAddProductGroup: true,
    }));
  };

  const handleCloseAddProductModal = () => {
    setState((prevData) => ({
      ...prevData,
      isAddProductGroup: false,
      newProductGroup: '',
      groupError: false,
      selectedIds: [],
    }));
  };

  const handleProductGroupInput = (val) => {
    setState((prevData) => ({
      ...prevData,
      newProductGroup: val,
    }));
  };

  const handleAddProductGroup = async () => {
    if (state?.newProductGroup?.trim()?.length > 0) {
      const obj = {
        productGroupName: state?.newProductGroup,
        seaction: 'masters',
        module: 'productGroups',
        action: 'addEdit',
        prodId: uniq(state?.selectedIds),
      };
      const res = await dispatch(action.addProductGroup(obj, t));
      if (res.code === 200) {
        await dispatch(productListAction.fetchProductGroup(t));
        handleCloseAddProductModal();
      }
    } else {
      setState((oldData) => ({ ...oldData, groupError: true }));
    }
  };

  const handleTrashConfirmed = async () => {
    setState((prevData) => ({ ...prevData, loader: true }));
    const obj = {
      doIds: uniq(state?.selectedIds),
    };
    const res = await dispatch(action.trashProduct(obj, t));
    if (res !== 200) {
      setState((prevData) => ({ ...prevData, loader: false }));
      return;
    }
    if (res === 200) {
      closeAcrhiveTrashDeleteModal();
      setState((prevData) => ({
        ...prevData,
        selectedIds: [],
        productData: [],
      }));
      if (state?.isLinkOpen) {
        const params = { archived: state?.activeList !== 'open' || false, devOrderId: state?.LinkId, deleted: state?.activeList === 'bin' || false };
        await dispatch(action.getReorderList(params));
      } else {
        getDevOrderList(0);
      }
    }
  };

  const getDevOrderList = async (index) => {
    setState((prevData) => ({
      ...prevData,
      pageIndex: index,
      pageLoading: true,
      productData: [],
    }));
    const payloadObj = {
      archived: state?.activeList !== 'open',
      count: index,
      searchText: state?.searchText,
      ...state?.filterData,
      ...state?.filterSort,
    };
    if (state?.selectedGroupId) {
      payloadObj.groupId = state?.selectedGroupId;
    }
    await callGetDevorderListApi(payloadObj);
  };

  const handleArchivedConfirmed = async () => {
    setState((prevData) => ({
      ...prevData,
      loader: true,
    }));
    const obj = {
      devOrderIds: uniq(state?.selectedIds),
      archieveComment: state?.archivedComment,
      isArchived: state?.activeList === 'open',
    };
    const res = await dispatch(action.archivedProduct(obj, t));
    if (res === 200) {
      setState((prevData) => ({
        ...prevData,
        selectedIds: [],
        archivedComment: '',
        productData: [],
        loader: false,
      }));
      closeAcrhiveTrashDeleteModal();
      if (state?.isLinkOpen) {
        const params = { archived: state?.activeList !== 'open' || false, devOrderId: state?.LinkId, deleted: state?.activeList === 'bin' || false };
        await dispatch(action.getReorderList(params));
      } else {
        getDevOrderList(0);
      }
    }
  };

  const closeAcrhiveTrashDeleteModal = () => {
    setState((prevData) => ({
      ...prevData,
      isArchivedModal: false,
      isTrashModal: false,
      isDeleteOpen: false,
      loader: false,
    }));
  };

  const handlePimStatusConfirmProceed = async () => {
    const { statusId } = state.pimStatusConfirm;
    setState((prevData) => ({ ...prevData, pimStatusConfirm: null }));
    const objStatus = { statusId, selectedProducts: state.selectedIds };
    const res = await dispatch(action.updateProductStatus(objStatus, t));
    if (res === 200) {
      setState((prevData) => ({ ...prevData, pageIndex: 0, pageLoading: true, selectedIds: [] }));
      await callGetDevorderListApi({
        archived: state.activeList !== 'open',
        count: 0,
        searchText: state.searchText,
        ...state.filterData,
        ...state.filterSort,
      });
    }
  };

  const handleDeleteConfirmed = async () => {
    const res = await dispatch(action.deleteProductData(state?.deletedDevOrderId, t));
    if (res === 200) {
      closeAcrhiveTrashDeleteModal();
      if (state?.isLinkOpen) {
        const params = { archived: state?.activeList !== 'open' || false, devOrderId: state?.LinkId, deleted: state?.activeList === 'bin' || false };
        await dispatch(action.getReorderList(params));
      } else {
        fetchBinProduct();
      }
    }
  };

  const fetchBinProduct = async () => {
    setState((prevData) => ({
      ...prevData,
      productData: [],
      productTotalCount: 0,
      activeList: 'bin',
    }));
    await callGetDevorderListApi({ archived: true, deleted: true });
  };

  const sureMessage = t('USER_GROUP_VIEW.SURE_MESSAGE');
  const archiveOrUnarchive = state?.activeList === 'open' ? t('USER_GROUP_VIEW.ARCHIVE_LOWER') : t('USER_GROUP_VIEW.UNARCHIVE_LOWER');
  const selectedProducts = t('USER_GROUP_VIEW.SELECTED_PRODUCTS');

  const message = `${sureMessage} ${archiveOrUnarchive} ${selectedProducts}`;

  return (
    <>
      <div className={state?.isLinkOpen ? '' : 'page-title-filter sticky product-info-title-bar'}>
        <ProductInfoSubHeader linkOpen={state?.isLinkOpen} />
      </div>

      {state?.isLinkOpen ? <ReorderList /> : <ProductListContainer />}
      {/* open completion indicator model */}
      {state?.isCompletionModalOpen && (
        <CompletionModal
          item={state?.currentProduct}
          show={state?.isCompletionModalOpen}
          completionData={state?.completionData}
          handleClose={handleCloseCompletionModal}
        />
      )}
      {/* modal to add edit product data */}
      {state?.isProductGroupModalOpen && (
        <ProductGroupModal
          item={state?.currentProduct}
          show={state?.isProductGroupModalOpen}
          handleClose={handleCloseProductModal}
          handleOpenProductGroup={handleOpenProductGroup}
          groupId={state?.selectedGroupId}
        />
      )}
      {state?.isAddProductGroup && (
        <AddProductGroupModal
          title={t('FILTER.ADD_PRODUCT_GROUPS')}
          label={t('USER_GROUP_VIEW.NAME')}
          show={state?.isAddProductGroup}
          handleClose={handleCloseAddProductModal}
          handleProductGroupInput={handleProductGroupInput}
          newProductGroup={state?.newProductGroup}
          hasError={state.groupError}
          handleAddProductGroup={handleAddProductGroup}
        />
      )}
      {state?.isArchivedModal && (
        <BombiixModal
          show={state?.isArchivedModal}
          title={state?.activeList === 'open' ? t('USER_GROUP_VIEW.ARCHIVE') : t('USER_GROUP_VIEW.UNARCHIVE')}
          onClose={closeAcrhiveTrashDeleteModal}
          onSave={() => handleArchivedConfirmed()}
          saveLabel={state?.activeList === 'open' ? t('USER_GROUP_VIEW.ARCHIVE') : t('USER_GROUP_VIEW.UNARCHIVE')}
          saveLoading={state?.loader}
          size="md"
        >
          <p className="mb-16 text-center">{message}</p>
          <NewTextArea
            rows={3}
            resize="vertical"
            maxLength={200}
            value={state?.archivedComment}
            placeholder={t('CONFIRMATION_POPUP.ENTER_COMMENT')}
            onChange={(event) =>
              setState((prevState) => ({
                ...prevState,
                archivedComment: event.target.value,
              }))
            }
          />
          <div className="character-counter">{state?.archivedComment?.length || 0}/200</div>
        </BombiixModal>
      )}
      {state?.isTrashModal && (
        <BombiixModal
          show={state?.isTrashModal}
          title={t('FILTER.DELETE_PRODUCT')}
          onClose={closeAcrhiveTrashDeleteModal}
          onSave={() => handleTrashConfirmed()}
          saveLoading={state?.loader}
          size="md"
        >
          <p className="mb-16 text-center">{t('FILTER.SELECTED_BIN_MESSAGE')}</p>
        </BombiixModal>
      )}
      {state?.isDeleteOpen && (
        <ConfirmationPopup
          onOpen={state?.isDeleteOpen}
          onConfirm={() => handleDeleteConfirmed()}
          title={t('FILTER.DELETE_PRODUCT')}
          message={t('FILTER.SELECTED_BIN_PERMANETLY_MESSAGE')}
          toggle={closeAcrhiveTrashDeleteModal}
          isCommentOn={false}
        />
      )}
      {state?.pimStatusConfirm && (
        <ConfirmationPopup
          onOpen={!!state.pimStatusConfirm}
          onConfirm={handlePimStatusConfirmProceed}
          title={t('PIM.STATUS_CHANGE_WARNING_TITLE', 'Change Product Status')}
          message={t('PIM.STATUS_CHANGE_WARNING_MESSAGE', `Changing status will permanently delete ${state.pimStatusConfirm.totalAffected} PIM row(s). This cannot be undone. Proceed?`)}
          toggle={() => setState((prevData) => ({ ...prevData, pimStatusConfirm: null }))}
          isCommentOn={false}
          requireTypedConfirmation
        />
      )}
    </>
  );
}

export default ProductInformation;
